import * as Yup from 'yup';

export const SetUpADriverAccountSchema = Yup.object().shape({
  profilePicture: Yup.mixed<File>()
    .required('An image is required')
    .test(
      'fileSize',
      'File size too large (Max: 15MB)',
      (value: File | null | undefined) => {
        return value ? value.size <= 15 * 1024 * 1024 : true; // 15MB limit
      },
    )
    .test(
      'fileType',
      'Unsupported file format',
      (value: File | null | undefined) => {
        return value
          ? ['image/jpeg', 'image/png', 'image/gif'].includes(value.type)
          : true;
      },
    ),
  firstName: Yup.string()
    .min(1, 'First name is required')
    .required('First name is required'),
  lastName: Yup.string()
    .min(1, 'Last name is required')
    .required('Last name is required'),
  email: Yup.string().email(),
  // .required('Email is required'),
  phoneNumber: Yup.string()
    .min(1, 'Phone number is required')
    .required('Phone number is required'),
  startDate: Yup.string()
    .min(1, 'Start date is required')
    .required('Start date is required'),
  gender: Yup.string()
    .min(1, 'Gender is required')
    .required('Gender is required'),
  fleetCategory: Yup.string()
    .min(1, 'Category of fleet is required')
    .required('Category of fleet is required'),
  dateOfBirth: Yup.string()
    .min(1, 'Date of birth is required')
    .required('Date of birth is required'),
  nin: Yup.string()
    .min(1, 'NIN number is required')
    .required('NIN number is required'),
  address: Yup.string()
    .min(1, 'Address is too Short')
    .required('Address is required'),
});

export type SetUpADriverAccountDataType = Yup.InferType<typeof SetUpADriverAccountSchema>;

type InitialValues = {
  profilePicture: File | null;
  firstName: String;
  lastName: String;
  email: String;
  phoneNumber: String;
  startDate: String;
  gender: String;
  fleetCategory: String;
  dateOfBirth: String;
  nin: String;
  address: String;
};

export const SetUpADriverAccountInitialValues: InitialValues = {
  profilePicture: null,
  firstName: '',
  lastName: '',
  email: '',
  phoneNumber: '',
  startDate: '',
  gender: '',
  fleetCategory: '',
  dateOfBirth: '',
  nin: '',
  address: '',
};

export interface SetUpADriverAccountInterface {
  profilePicture: string;
  firstName: String;
  lastName: String;
  email: String;
  phoneNumber: String;
  startDate: String;
  gender: String;
  fleetCategory: String;
  dateOfBirth: String;
  nin: String;
  address: String;
};

